import { put, select, takeEvery, takeLatest, throttle } from 'redux-saga/effects'

import * as actions from './savePoint.actions'
import * as authSelectors from '../Auth/auth.selectors'
import * as firebaseSelectors from '../Firebase/firebase.selectors'

import * as i18nActions from '../i18n/i18n.actions'
import errors from './savePoint.errors'
import * as gameActions from '../Game/game.actions'
import * as gameSelectors from '../Game/game.selectors'
import * as selectors from './savePoint.selectors'
import Api from '../Api'

const BEHAVIORS = {
  redirect: function* (target) {
    if (process.env.NODE_ENV === 'development') {
      yield put(gameActions.showError('CRITICAL_ERROR'))
      return
    }

    if (target === 'students_platform') {
      yield put(gameActions.returnToPlatform())
    }
  },
  reload: function* () {
    yield put(gameActions.reload())
  },
  showError: function* (errorType) {
    yield put(gameActions.showError(errorType))
  },
}

/**
 *  Initiate the saving process of the save point
 */
function* startSave() {
  const userInfo = yield select(authSelectors.getUserInfo)
  const playerData = yield select(firebaseSelectors.getPlayerData)
  const groupData = yield select(firebaseSelectors.getGroupData)
  const savePoint = yield select(selectors.getSavePoint)

  savePoint.currentTurn = playerData.turn
  savePoint.session = groupData.session
  savePoint.maxTurns = groupData.sessions * groupData.maxTurns
  savePoint.coins = playerData.coins
  savePoint.settlers = playerData.settlers

  try {
    const response = yield Api.put('/games-core/player/' + userInfo.id, {}, savePoint)

    yield put(actions.finishSaveOk(response))
  } catch (e) {
    yield put(actions.finishSaveError(e))
  }
}

/**
 *  Synchronize save point with game info
 */
function* syncWithGame() {
  const game = yield select(gameSelectors.getGame)

  yield put(actions.syncWithGame(game))
  yield put(actions.startSave())
}

/**
 *  Synchronize save point with user info from login
 */
function* syncWithUserInfo() {
  const userInfo = yield select(authSelectors.getUserInfo)
  yield put(actions.syncWithUserInfo(userInfo))

  yield put({ type: actions.LOADED })
}

/**
 *  Handle the saving error from server.
 */
function* handleSavingError(action) {
  const { code, errorCode } = action.data || {}
  const error = errors[code] || errors[errorCode]
  
  if (!error) {
    console.warn('Unknown error code:', code, errorCode)
    yield put(gameActions.showError('UNKNOWN_ERROR'))
    return
  }
  
  const behavior = BEHAVIORS[error.action]
  if (!behavior) {
    console.warn('Unknown behavior:', error.action)
    yield put(gameActions.showError('UNKNOWN_ERROR'))
    return
  }
  
  yield behavior(error.target)
}

/**
 *  Save point sagas entrypoint
 */
export function* sagas() {
  yield throttle(500, actions.SAVE_START, startSave)
  yield takeEvery(i18nActions.LOAD_MESSAGES_FINISH, syncWithUserInfo)
  yield takeLatest(gameActions.CHANGE_SCENE_FINISH, syncWithGame)
  yield takeEvery(actions.SAVE_FINISH_ERROR, handleSavingError)
}
